
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type UpdateConversation200LastMessageRole = typeof UpdateConversation200LastMessageRole[keyof typeof UpdateConversation200LastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateConversation200LastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
